import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//amplify
// import Amplify from "@aws-amplify/core";
// import { Logger } from "@aws-amplify/core";
// import { I18n } from "@aws-amplify/core";
// import Auth from "@aws-amplify/auth";
// import { AuthClass } from "@aws-amplify/auth";
import Amplify, * as AmplifyModules from "aws-amplify";

// @ts-ignore
import { AmplifyPlugin } from "aws-amplify-vue";
// @ts-ignore
import aws_exports from "./aws-exports";
Amplify.configure(aws_exports);

const languageDict = {
  ja: {
    "Sign in to your account": "アカウントにサインイン",
    Username: "メールアドレス",
    "Enter your Username": "メールアドレスを入力してください",
    Password: "パスワード",
    "Enter your password": "パスワードを入力してください",
    "Forget your password? ": "パスワードを忘れた場合",
    "Reset password": "パスワードのリセット",
    "No account? ": "まだアカウントがない場合",
    "Create account": "アカウント作成",
    "Create a new account": "アカウント作成",
    "Have an account? ": "アカウントをお持ちの場合",
    "Sign In": "サインイン",
    "Sign in": "サインイン",
    "Create Account": "アカウント作成",
    "Confirm Sign Up": "送られたメールの確認コードを入力してください",
    Confirm: "確認",
    "Confirmation Code": "確認コード",
    "Back to Sign In": "サインインに戻る",
    "User does not exist.": "ユーザが存在しません。"
  }
};
Amplify.I18n.putVocabularies(languageDict);
Amplify.I18n.setLanguage("ja");
Vue.use(AmplifyPlugin, AmplifyModules);

//bootstrap-vue
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {
  AlertPlugin,
  ButtonPlugin,
  CardPlugin,
  FormCheckboxPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormTextareaPlugin,
  InputGroupPlugin,
  LayoutPlugin,
  ModalPlugin,
  NavbarPlugin
} from "bootstrap-vue";
Vue.use(AlertPlugin);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(InputGroupPlugin);
Vue.use(LayoutPlugin);
Vue.use(ModalPlugin);
Vue.use(NavbarPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
